module.exports = __webpack_public_path__ + "static/media/newlogo.07f631e4.png";